import React from 'react';

function qpapers(){
    return(
        <div className = "books">
        <h1 id="title">PAPERS</h1>
<nav id="tree-list">
    <ul className="container">
        <li>
            <h3 data-aos="flip-left">Engg. Maths - 1</h3>
            <ul className="tree-down"  data-aos="fade-up">
                <li>Paper 1<a href="https://drive.google.com/open?id=1uYQBoGlhmH6FdfSqdJrPCw62kA_arMlp"><img src="https://media.istockphoto.com/vectors/download-icon-isolated-vector-vector-id844294300?b=1&k=6&m=844294300&s=170x170&h=PJYj3qPn7fw7kD3RJ69J2KCISM949mLClsi78FT_djA=" alt="Download"/></a></li>
                <li>Paper 2<a href="https://drive.google.com/open?id=1wigtLGeoWtacQ525ULhcQhRunZi-P_yp"><img src="https://media.istockphoto.com/vectors/download-icon-isolated-vector-vector-id844294300?b=1&k=6&m=844294300&s=170x170&h=PJYj3qPn7fw7kD3RJ69J2KCISM949mLClsi78FT_djA=" alt="Download"/></a></li>
            </ul>
        </li>
        <li>
            <h3 data-aos="flip-left">Engg. Maths - 2</h3>
            <ul className="tree-down"  data-aos="fade-up">
                <li>Paper - 1<a href="https://drive.google.com/open?id=1bbdR1VWN8LimefsELlGvgGGGT0xozUD2"><img src="https://media.istockphoto.com/vectors/download-icon-isolated-vector-vector-id844294300?b=1&k=6&m=844294300&s=170x170&h=PJYj3qPn7fw7kD3RJ69J2KCISM949mLClsi78FT_djA=" alt="Download"/></a></li>
                <li>Paper - 2<a href="https://drive.google.com/open?id=1Cyc9e-KEbroorSmhS5AaX8eEkq-ekdmD"><img src="https://media.istockphoto.com/vectors/download-icon-isolated-vector-vector-id844294300?b=1&k=6&m=844294300&s=170x170&h=PJYj3qPn7fw7kD3RJ69J2KCISM949mLClsi78FT_djA=" alt="Download"/></a></li>
            </ul>
        </li>
        </ul>
</nav>
</div>
    )
}

export default qpapers;